(function() {
  'use strict';
  
  function initMulticolumnDots() {
    // Find all sliders with dots enabled
    const sliders = document.querySelectorAll('.multicolumn-with-dots.swipe-mobile');
    
    if (!sliders.length) return;
    
    sliders.forEach((slider) => {
      // Skip if already initialized
      if (slider.dataset.dotsInitialized === 'true') {
        return;
      }
      
      // const pagination = slider.querySelector('.multicolumn-pagination');
      const pagination = slider.parentElement.querySelector('.multicolumn-pagination');
      const dots = pagination ? Array.from(pagination.querySelectorAll('.multicolumn-pagination-dot')) : [];
      const items = slider.querySelector('.swipe-mobile__inner');
      
      if (!pagination || !dots.length || !items) {
        return;
      }
      
      const columnsMobile = parseInt(slider.dataset.columnsMobile) || 1;
      const itemsArray = Array.from(items.children);
      
      if (!itemsArray.length) return;
      
      // Mark as initialized
      slider.dataset.dotsInitialized = 'true';
      
      // Update active dot function
      function updateDots() {
        if (!slider || !items || !dots.length) return;
        
        const scrollLeft = slider.scrollLeft;
        const sliderComputed = window.getComputedStyle(slider);
        const paddingLeft = parseFloat(sliderComputed.paddingLeft) || 0;
        
        // Find which item is closest to the scroll position
        let activeItemIndex = 0;
        let closestDistance = Infinity;
        
        itemsArray.forEach((item, index) => {
          const itemLeft = item.offsetLeft;
          const distance = Math.abs(itemLeft - (scrollLeft + paddingLeft));
          
          if (distance < closestDistance) {
            closestDistance = distance;
            activeItemIndex = index;
          }
        });
        
        // Calculate dot index
        const dotIndex = Math.floor(activeItemIndex / columnsMobile);
        const activeDotIndex = Math.max(0, Math.min(dotIndex, dots.length - 1));
        
        // Update dots
        dots.forEach((dot, index) => {
          if (index === activeDotIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }
      
      // Handle dot clicks
      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          const targetItemIndex = dotIndex * columnsMobile;
          const targetItem = itemsArray[targetItemIndex];
          
          if (targetItem) {
            const sliderComputed = window.getComputedStyle(slider);
            const paddingLeft = parseFloat(sliderComputed.paddingLeft) || 0;
            const targetScroll = Math.max(0, targetItem.offsetLeft - paddingLeft);
            
            slider.scrollTo({
              left: targetScroll,
              behavior: 'smooth'
            });
          }
        });
      });
      
      // Track scroll
      slider.addEventListener('scroll', updateDots, { passive: true });
      
      // Initial update
      setTimeout(updateDots, 100);
      
      // Update on resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateDots, 150);
      });
    });
  }
  
  // Initialize multiple times to catch late-loading elements
  function startInit() {
    initMulticolumnDots();
    setTimeout(initMulticolumnDots, 300);
    setTimeout(initMulticolumnDots, 800);
    setTimeout(initMulticolumnDots, 1500);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInit);
  } else {
    startInit();
  }
  
  // Re-initialize for theme editor
  document.addEventListener('shopify:section:load', function() {
    // Reset flags
    document.querySelectorAll('.multicolumn-with-dots.swipe-mobile').forEach(slider => {
      slider.dataset.dotsInitialized = 'false';
    });
    setTimeout(initMulticolumnDots, 300);
    setTimeout(initMulticolumnDots, 800);
  });
  
  // Watch for new elements being added
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (
              node.classList && node.classList.contains('multicolumn-with-dots') ||
              node.querySelector && node.querySelector('.multicolumn-with-dots')
            )) {
              shouldCheck = true;
            }
          });
        }
      });
      if (shouldCheck) {
        setTimeout(initMulticolumnDots, 200);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
